module.exports = __webpack_public_path__ + "img/4_img.d18fb61b.png";